export enum SecurableObjectType {
  none = 0,
  state = 1,
  interactionQueueColumn = 2,
  businessProcess = 3
}
